import { render } from "./EvTraining.vue?vue&type=template&id=ebbb9460&scoped=true"
import script from "./EvTraining.vue?vue&type=script&lang=js"
export * from "./EvTraining.vue?vue&type=script&lang=js"

import "./EvTraining.vue?vue&type=style&index=0&id=ebbb9460&scoped=true&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbb9460"]])

export default __exports__